import { sendCloudWatchAlert } from './applicationError';

const createImage = async url => {
  const image = new Image();
  try {
    image.crossOrigin = 'anonymous';
    image.src = url;
    await image.decode();
  } catch (err) {
    sendCloudWatchAlert(`Image can't be decoded ${url} ${err}`);
  }
  return image;
};
export const getCroppedImg = async (imageSrc, pixelCrop) => {
  const image = await createImage(imageSrc);
  let croppedImage = '';
  const canvas = document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = 'transparent';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  croppedImage = canvas.toDataURL('image/png');
  return croppedImage;
};
